import { render, staticRenderFns } from "./ModalAtendimentoVazio.vue?vue&type=template&id=a5914b5c&scoped=true&"
import script from "./ModalAtendimentoVazio.vue?vue&type=script&lang=js&"
export * from "./ModalAtendimentoVazio.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtendimentoVazio.vue?vue&type=style&index=0&id=a5914b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5914b5c",
  null
  
)

export default component.exports